<template>
  <b-modal
    id="notification-wa-modal"
    modal-class="notification-wa-modal-container"
    hide-header
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    centered
    @hidden="handleHide"
  >
    <MainPage v-show="page === 1" ref="mainPageRef" class="page-1-container" @change-page="changePage" />
    <LocationInputPage v-if="page === 2" @change-page="changePage" />
    <LoadingPage v-else-if="page === 3" @change-page="changePage" />
    <ResultPage v-else-if="page === 4" :isSuccess="isSuccess" @change-page="changePage" />
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'

import MainPage from './contents/MainPage'
import LocationInputPage from './contents/LocationInputPage'
import LoadingPage from './contents/LoadingPage'
import ResultPage from './contents/ResultPage'

import moment from 'moment'
import { EventBus } from '../../lib/event-bus'

import { UPSERT_CONTACT_LOCATION_TEMPORARY } from '@/services/api/trackingTemporary/temporary'

export default {
  components: {
    MainPage,
    LocationInputPage,
    LoadingPage,
    ResultPage,
  },
  data() {
    return {
      page: 1,
      isSuccess: true,
    }
  },
  computed: {
    ...mapState('trackingTemp', ['formValues','isAnimationLoading', "formErrors"]),
  },
  created() {
    EventBus.$on('handle-submit-notif-wa', this.handleSubmitNotifWa)
  },
  destroyed() {
    EventBus.$off('handle-submit-notif-wa')
  },
  methods: {
    changePage(num) {
      this.page = num
    },
    async handleSubmitNotifWa() {
      try {
        const hasError = this.$refs.mainPageRef.ValidateForm()

        if (hasError) {
          this.page = 1
          return
        }

        this.$store.dispatch('trackingTemp/setIsApiFetching', true)

        // change to loading page if no error
        this.page = 3

        let upsertData = await this.$apollo.mutate({
          mutation: UPSERT_CONTACT_LOCATION_TEMPORARY,
          variables: {
            input: {
              contact: {
                location: this.formValues.address,
                phoneNumber: this.formValues.phone_number,
              },
              temporaryLiveViewId: Number(this.$route.params.id),
            },
          },
        })

        const response = upsertData.data.upsertContactLocationToTempLiveView

        if (!response.isSuccessful) {
          this.isSuccess = false

          if (!this.isAnimationLoading) {
            this.page = 4
          } else {
            this.$store.dispatch('trackingTemp/setIsApiFetching', false)
          }

          if (response.errorName === "InvalidPhoneNumberFormat") {
            this.$set(this.formErrors, "phone_number", this.$t('global.validation.invalidNumber'))
          }
          return
        }

        this.isSuccess = true

        if (!this.isAnimationLoading) {
          this.page = 4
        } else {
          this.$store.dispatch('trackingTemp/setIsApiFetching', false)
        }
      } catch(e) {
        this.isSuccess = false

        if (this.isLoadingAnimation) {
          this.page = 4
        } else {
          this.$store.dispatch('trackingTemp/setIsApiFetching', false)
        }
      }
    },
    handleHide() {
      var showedNotifyMeTempTrack = JSON.parse(localStorage.getItem("showedNotifyMeTempTrack")) || {}

      if (showedNotifyMeTempTrack[this.$route.params.id] === undefined) {
        showedNotifyMeTempTrack[this.$route.params.id] = true

        localStorage.setItem(
          'showedNotifyMeTempTrack',
          JSON.stringify(showedNotifyMeTempTrack)
        )
      }

      this.page = 1
    }
  },
}
</script>

<style lang="scss">
@import '@/design/custom/pages/_trackingtemp.scss';
</style>